import { NumberInput, type NumberInputProps } from '@mantine/core';

type MoneyInputProps = Omit<NumberInputProps, 'value' | 'onChange'> & {
  value: number | null;
  onChange: (val: number | null) => void;
};

export function MoneyInput({ value, onChange, ...rest }: MoneyInputProps) {
  return (
    <NumberInput
      {...rest}
      value={value ?? ''}
      onChange={(val) => {
        if (val === '' || val === undefined) onChange(null);
        else onChange(typeof val === 'number' ? val : Number(val));
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      suffix=" €"
      min={0}
      step={0.01}
    />
  );
}
